export default "__VITE_ASSET__BXlDuVEr__"